import {useMemo} from "react";
import _ from "lodash";
import {useAtomValue} from "jotai";
import {getAccessUtilsClosureTSQ} from "../utils/accessControlUtils";
import {authenticatedUserLoadable} from "../store/authenticatedUserStore";
import {AccessFunctions} from "../types/accessControl";
import {activeUserLoadable} from "../store/activeUserStore";
import {useCompany} from "./companiesHooks";

export const useAccessMarker = <T extends string>(
    accessFunctions: AccessFunctions<T>,
): Record<T | "hasData", boolean> => {
    const authenticatedUserState = useAtomValue(authenticatedUserLoadable);
    const activeCompanyState = useCompany();
    const activeUserState = useAtomValue(activeUserLoadable);

    return useMemo(() => {
        const accessUtils = getAccessUtilsClosureTSQ(
            authenticatedUserState,
            activeCompanyState.data,
            activeCompanyState.isSuccess,
            activeUserState,
        );

        return {
            ..._.mapValues(accessFunctions, (accessFn) => accessFn(accessUtils)),
            hasData:
                authenticatedUserState.state === "hasData" &&
                activeCompanyState.isSuccess &&
                activeUserState.state === "hasData",
        };
    }, [
        authenticatedUserState,
        activeCompanyState.isSuccess,
        activeCompanyState.data,
        activeUserState,
        accessFunctions,
    ]);
};
